import { millicentsToDollars } from 'utils/money';
import { PriceCard } from './types';

export const getMinCustomBudget = (pricesList: PriceCard[]): number =>
  millicentsToDollars(pricesList[pricesList.length - 1]?.value ?? 0) + 1;

export const getPurchasablePrices = (
  pricesList: PriceCard[],
  isProGrow?: boolean,
): PriceCard[] =>
  pricesList.filter(({ type }) => type !== 'proGrow' || isProGrow);

export const isPriceAvailable = (
  pricesList: PriceCard[],
  value?: number,
): boolean => pricesList.some((price) => price.value === value);
